import React from 'react'
import { Box, styled } from '@mui/material'
import { useApplicationSettings } from 'hooks'
import ItemCard from 'components/ItemCard'
import { mobileScreenWidth } from 'utils'

const Container = styled(Box)({
    height: 'inline-block',
    width: '33%',

    overflow: 'hidden',
    [`@media (max-width:${mobileScreenWidth})`]: {
        width: '100%',
    },
})

const ReportCard = ({ item, attributes }) => {
    const { data: appConfig } = useApplicationSettings()

    return (
        <Container>
            <ItemCard
                cardStyles={{
                    margin: '14px',
                }}
                headerStyles={{
                    backgroundImage: appConfig.style.colors.primary?.gradient,
                    backgroundColor: appConfig.style.colors.primary?.header,
                    padding: '20px',
                }}
                buttonStyles={{
                    backgroundColor: `${appConfig.style.colors.primary?.button} !important`,
                    boxShadow:
                        '0 5px 5px -2px rgba(48, 127, 193, 0.55) !important',
                }}
                attributes={attributes}
                item={item}
                showDetailsButton={false}
            />
        </Container>
    )
}

export default ReportCard
